const mailBody = (name, message, timestamp, cat) => {
  const currentYear = new Date().getFullYear();
  return /* HTML */ ` <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html
      xmlns="http://www.w3.org/1999/xhtml"
      xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office"
    >
      <head>
        <!--[if gte mso 9]>
          <xml>
            <o:OfficeDocumentSettings>
              <o:AllowPNG />
              <o:PixelsPerInch>96</o:PixelsPerInch>
            </o:OfficeDocumentSettings>
          </xml>
        <![endif]-->
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="x-apple-disable-message-reformatting" />
        <!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <!--<![endif]-->
        <title></title>

        <style type="text/css">
          @media only screen and (min-width: 680px) {
            .u-row {
              width: 660px !important;
            }
            .u-row .u-col {
              vertical-align: top;
            }
            .u-row .u-col-50 {
              width: 330px !important;
            }
            .u-row .u-col-100 {
              width: 660px !important;
            }
          }

          @media (max-width: 680px) {
            .u-row-container {
              max-width: 100% !important;
              padding-left: 0px !important;
              padding-right: 0px !important;
            }
            .u-row .u-col {
              min-width: 320px !important;
              max-width: 100% !important;
              display: block !important;
            }
            .u-row {
              width: calc(100% - 40px) !important;
            }
            .u-col {
              width: 100% !important;
            }
            .u-col > div {
              margin: 0 auto;
            }
            .no-stack .u-col {
              min-width: 0 !important;
              display: table-cell !important;
            }
            .no-stack .u-col-50 {
              width: 50% !important;
            }
          }

          body {
            margin: 0;
            padding: 0;
          }

          table,
          tr,
          td {
            vertical-align: top;
            border-collapse: collapse;
          }

          p {
            margin: 0;
          }

          .ie-container table,
          .mso-container table {
            table-layout: fixed;
          }

          * {
            line-height: inherit;
          }

          a[x-apple-data-detectors="true"] {
            color: inherit !important;
            text-decoration: none !important;
          }

          table,
          td {
            color: #ffffff;
          }

          #u_body a {
            color: #ffffff;
            text-decoration: underline;
          }

          #u_content_heading_1 a {
            text-decoration: none;
          }

          @media (max-width: 480px) {
            #u_content_heading_1 a {
              color: #ffffff !important;
              text-decoration: none !important;
            }
            #u_content_heading_1 a:hover {
              color: #ffffff !important;
              background-color: underline !important;
            }
            #u_content_text_4 .v-container-padding-padding {
              padding: 31px !important;
            }
            #u_content_text_11 .v-container-padding-padding {
              padding: 20px 55px 55px !important;
            }
            #u_content_text_6 .v-container-padding-padding {
              padding: 20px 55px 55px !important;
            }
            #u_content_text_8 .v-container-padding-padding {
              padding: 21px 31px 10px !important;
            }
            #u_content_text_9 .v-container-padding-padding {
              padding: 10px 55px !important;
            }
            #u_content_social_2 .v-container-padding-padding {
              padding: 12px 12px 12px 31px !important;
            }
            #u_content_button_1 .v-padding {
              padding: 4px 31px 4px 0px !important;
            }
          }
        </style>
      </head>

      <body
        class="clean-body u_body"
        style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #0c0b0e;color: #ffffff"
      >
        <!--[if IE]><div class="ie-container"><![endif]-->
        <!--[if mso]><div class="mso-container"><![endif]-->
        <table
          id="u_body"
          style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #0c0b0e;width:100%"
          cellpadding="0"
          cellspacing="0"
        >
          <tbody>
            <tr>
              <td
                style="display:none !important;visibility:hidden;mso-hide:all;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;"
              >
                Contatto ricevuto!
              </td>
            </tr>

            <tr style="vertical-align: top">
              <td
                style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"
              >
                <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #0c0b0e;"><![endif]-->

                <div
                  class="u-row-container"
                  style="padding: 0px;background-color: transparent"
                >
                  <div
                    class="u-row"
                    style="Margin: 0 auto;min-width: 320px;max-width: 660px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #0c0b0e;"
                  >
                    <div
                      style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;"
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:660px;"><tr style="background-color: #0c0b0e;"><![endif]-->

                      <!--[if (mso)|(IE)]><td align="center" width="660" style="width: 660px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-100"
                        style="max-width: 320px;min-width: 660px;display: table-cell;vertical-align: top;"
                      >
                        <div
                          style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                        >
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                          >
                            <!--<![endif]-->

                            <table
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:40px 10px 0px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <table
                                      width="100%"
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                    >
                                      <tr>
                                        <td
                                          style="padding-right: 0px;padding-left: 0px;"
                                          align="center"
                                        >
                                          <img
                                            align="center"
                                            border="0"
                                            src="https://www.tempiodelfuturo.art/logo-64.png"
                                            alt="Image"
                                            title="Image"
                                            style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 100%;max-width: 64px;"
                                            width="64"
                                          />
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <table
                              id="u_content_heading_1"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:10px 10px 30px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <h1
                                      style="margin: 0px; color: #ffffff; line-height: 140%; text-align: center; word-wrap: break-word; font-weight: normal; font-size: 22px;"
                                    >
                                      <strong
                                        ><a
                                          rel="noopener"
                                          href="https://www.tempiodelfuturo.art/"
                                          target="_blank"
                                          >TEMPIO DEL FUTURO *PERDUTO</a
                                        ></strong
                                      >
                                    </h1>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>

                <div
                  class="u-row-container"
                  style="padding: 0px;background-color: transparent"
                >
                  <div
                    class="u-row"
                    style="Margin: 0 auto;min-width: 320px;max-width: 660px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #e4eaf8;"
                  >
                    <div
                      style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;"
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:660px;"><tr style="background-color: #e4eaf8;"><![endif]-->

                      <!--[if (mso)|(IE)]><td align="center" width="660" style="width: 660px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-100"
                        style="max-width: 320px;min-width: 660px;display: table-cell;vertical-align: top;"
                      >
                        <div style="height: 100%;width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"
                          >
                            <!--<![endif]-->

                            <table
                              id="u_content_text_4"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:31px 10px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div
                                      style="color: #6e66e0; line-height: 140%; text-align: center; word-wrap: break-word;"
                                    >
                                      <p
                                        style="font-size: 14px; line-height: 140%; text-align: center;"
                                      >
                                        <span
                                          style="font-size: 28px; line-height: 39.2px;"
                                          ><strong
                                            ><span
                                              style="line-height: 39.2px; font-size: 28px;"
                                              >Abbiamo ricevuto la tua
                                              richiesta</span
                                            ></strong
                                          >
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <table
                              id="u_content_text_11"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:33px 55px 55px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div
                                      style="color: #000000; line-height: 160%; text-align: center; word-wrap: break-word;"
                                    >
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                        <span
                                          style="font-size: 22px; line-height: 35.2px;"
                                          >Ciao ${name},</span
                                        >
                                      </p>
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                        <span
                                          style="font-size: 22px; line-height: 35.2px;"
                                          >grazie per averci contattato! Ti
                                          risponderemo al più presto.</span
                                        >
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>

                <div
                  class="u-row-container"
                  style="padding: 0px;background-color: transparent"
                >
                  <div
                    class="u-row"
                    style="Margin: 0 auto;min-width: 320px;max-width: 660px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #e4eaf8;"
                  >
                    <div
                      style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;"
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:660px;"><tr style="background-color: #e4eaf8;"><![endif]-->

                      <!--[if (mso)|(IE)]><td align="center" width="660" style="width: 660px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-100"
                        style="max-width: 320px;min-width: 660px;display: table-cell;vertical-align: top;"
                      >
                        <div style="height: 100%;width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"
                          >
                            <!--<![endif]-->

                            <table
                              id="u_content_text_6"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:33px 55px 55px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div
                                      style="color: #000000; line-height: 160%; text-align: center; word-wrap: break-word;"
                                    >
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                        <span
                                          style="font-size: 18px; line-height: 28.8px;"
                                          >Messaggio originale del
                                          ${timestamp}</span
                                        >
                                      </p>
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                        <span
                                          style="font-size: 18px; line-height: 28.8px;"
                                          >Categoria: ${cat}</span
                                        ><span
                                          style="font-size: 22px; line-height: 35.2px;"
                                        ></span>
                                      </p>
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                         
                                      </p>
                                      <p
                                        style="line-height: 160%; text-align: left; font-size: 14px;"
                                      >
                                        <span
                                          style="font-size: 16px; line-height: 25.6px;"
                                          ><strong
                                            ><span
                                              style="line-height: 25.6px; font-family: 'courier new', courier; color: #6e66e0; font-size: 16px; white-space: pre-line;"
                                              >"${message}"</span
                                            ></strong
                                          >
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>

                <div
                  class="u-row-container"
                  style="padding: 0px;background-color: transparent"
                >
                  <div
                    class="u-row"
                    style="Margin: 0 auto;min-width: 320px;max-width: 660px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #0c0b0e;"
                  >
                    <div
                      style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;"
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:660px;"><tr style="background-color: #0c0b0e;"><![endif]-->

                      <!--[if (mso)|(IE)]><td align="center" width="660" style="width: 660px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-100"
                        style="max-width: 320px;min-width: 660px;display: table-cell;vertical-align: top;"
                      >
                        <div style="height: 100%;width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"
                          >
                            <!--<![endif]-->

                            <table
                              id="u_content_text_8"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:21px 10px 10px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div
                                      style="color: #fafafa; line-height: 180%; text-align: center; word-wrap: break-word;"
                                    >
                                      <p
                                        style="font-size: 14px; line-height: 180%;"
                                      >
                                        <span
                                          style="font-size: 14px; line-height: 25.2px;"
                                          ><strong
                                            ><span
                                              style="line-height: 25.2px; font-size: 14px;"
                                              >${currentYear}  &copy;
                                              TDF*P</span
                                            ></strong
                                          >
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <table
                              id="u_content_text_9"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:0px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div
                                      style="color: #fafafa; line-height: 180%; text-align: center; word-wrap: break-word;"
                                    >
                                      <p
                                        style="font-size: 14px; line-height: 180%;"
                                      >
                                        <span
                                          style="font-size: 12px; line-height: 21.6px;"
                                          ><span
                                            style="line-height: 21.6px; font-size: 12px;"
                                            >Questa è una e-mail automatizzata.
                                            Non rispondere a questo
                                            messaggio.</span
                                          ></span
                                        >
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>

                <div
                  class="u-row-container"
                  style="padding: 0px;background-color: transparent"
                >
                  <div
                    class="u-row no-stack"
                    style="Margin: 0 auto;min-width: 320px;max-width: 660px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #0c0b0e;"
                  >
                    <div
                      style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;"
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:660px;"><tr style="background-color: #0c0b0e;"><![endif]-->

                      <!--[if (mso)|(IE)]><td align="center" width="330" style="width: 330px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-50"
                        style="max-width: 320px;min-width: 330px;display: table-cell;vertical-align: top;"
                      >
                        <div
                          style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                        >
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                          >
                            <!--<![endif]-->

                            <table
                              id="u_content_social_2"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:12px 12px 12px 55px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <div align="left">
                                      <div
                                        style="display: table; max-width:73px;"
                                      >
                                        <!--[if (mso)|(IE)]><table width="73" cellpadding="0" cellspacing="0" border="0"><tr><td style="border-collapse:collapse;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse; mso-table-lspace: 0pt;mso-table-rspace: 0pt; width:73px;"><tr><![endif]-->

                                        <!--[if (mso)|(IE)]><td width="32" style="width:32px; padding-right: 5px;" valign="top"><![endif]-->
                                        <table
                                          align="left"
                                          border="0"
                                          cellspacing="0"
                                          cellpadding="0"
                                          width="32"
                                          height="32"
                                          style="width: 32px !important;height: 32px !important;display: inline-block;border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;margin-right: 5px"
                                        >
                                          <tbody>
                                            <tr style="vertical-align: top">
                                              <td
                                                align="left"
                                                valign="middle"
                                                style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"
                                              >
                                                <a
                                                  href="https://facebook.com/tempiodelfuturoperduto"
                                                  title="Facebook"
                                                  target="_blank"
                                                >
                                                  <img
                                                    src="https://www.tempiodelfuturo.art/fb-icon.png"
                                                    alt="Facebook"
                                                    title="Facebook"
                                                    width="18"
                                                    style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: block !important;border: none;height: auto;float: none;max-width: 18px !important"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <!--[if (mso)|(IE)]></td><![endif]-->

                                        <!--[if (mso)|(IE)]><td width="32" style="width:32px; padding-right: 0px;" valign="top"><![endif]-->
                                        <table
                                          align="left"
                                          border="0"
                                          cellspacing="0"
                                          cellpadding="0"
                                          width="32"
                                          height="32"
                                          style="width: 32px !important;height: 32px !important;display: inline-block;border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;margin-right: 0px"
                                        >
                                          <tbody>
                                            <tr style="vertical-align: top">
                                              <td
                                                align="left"
                                                valign="middle"
                                                style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"
                                              >
                                                <a
                                                  href="https://instagram.com/tempiodelfuturoperduto"
                                                  title="Instagram"
                                                  target="_blank"
                                                >
                                                  <img
                                                    src="https://www.tempiodelfuturo.art/ig-icon.png"
                                                    alt="Instagram"
                                                    title="Instagram"
                                                    width="18"
                                                    style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: block !important;border: none;height: auto;float: none;max-width: 18px !important"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <!--[if (mso)|(IE)]></td><![endif]-->

                                        <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="330" style="width: 330px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
                      <div
                        class="u-col u-col-50"
                        style="max-width: 320px;min-width: 330px;display: table-cell;vertical-align: top;"
                      >
                        <div
                          style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                        >
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"
                          >
                            <!--<![endif]-->

                            <table
                              id="u_content_button_1"
                              style="font-family:arial,avant garde,arial;"
                              role="presentation"
                              cellpadding="0"
                              cellspacing="0"
                              width="100%"
                              border="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    class="v-container-padding-padding"
                                    style="overflow-wrap:break-word;word-break:break-word;padding:16px;font-family:arial,avant garde,arial;"
                                    align="left"
                                  >
                                    <!--[if mso
                                      ]><style>
                                        .v-button {
                                          background: transparent !important;
                                        }
                                      </style><!
                                    [endif]-->
                                    <div align="right">
                                      <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://www.tempiodelfuturo.art/privacy" style="height:25px; v-text-anchor:middle; width:119px;" arcsize="32%"  stroke="f" fillcolor="#0c0b0e"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,avant garde,arial;"><![endif]-->
                                      <a
                                        href="https://www.tempiodelfuturo.art/privacy"
                                        target="_blank"
                                        class="v-button"
                                        style="box-sizing: border-box;display: inline-block;font-family:arial,avant garde,arial;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #0c0b0e; border-radius: 8px;-webkit-border-radius: 8px; -moz-border-radius: 8px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"
                                      >
                                        <span
                                          class="v-padding"
                                          style="display:block;padding:4px 55px 4px 12px;line-height:120%;"
                                          ><span
                                            style="font-size: 12px; line-height: 14.4px;"
                                            ><strong
                                              ><span
                                                style="line-height: 14.4px; font-size: 12px;"
                                                >PRIVACY</span
                                              ></strong
                                            >
                                          </span>
                                        </span>
                                      </a>
                                      <!--[if mso]></center></v:roundrect><![endif]-->
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td><![endif]-->
                      <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>

                <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
        <!--[if mso]></div><![endif]-->
        <!--[if IE]></div><![endif]-->
      </body>
    </html>`;
};

export default mailBody;
